import { render, staticRenderFns } from "./UpdatePaymentSetting.vue?vue&type=template&id=2c665216"
import script from "./UpdatePaymentSetting.vue?vue&type=script&lang=js"
export * from "./UpdatePaymentSetting.vue?vue&type=script&lang=js"
import style0 from "./UpdatePaymentSetting.vue?vue&type=style&index=0&id=2c665216&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports